import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Grid,
} from '@material-ui/core';
import moment from 'moment';
import { globalDateEntity } from '../../constants/applicationConstants';

const ProcedureCodeImports = ({ job }) => {
    const getTotalSkippedRecords = ({ skipped, failed }) => {
        let count = 0;
        try {
            if (skipped && skipped >= 0) {
                count = count + skipped;
            }
            if (failed && !isNaN(failed) && failed >= 0) {
                count = count + failed;
            }
        } catch (e) {
            console.log(e);
            return 0;
        }
        return count;
    }

    const getTotalProcessedRecords = ({ skipped, added, updated }) => {
        let count = 0;
        try {
            if (skipped && !isNaN(skipped) && skipped >= 0) {
                count = count + skipped;
            }
            // if (failed && !isNaN(failed) && failed >= 0) {
            //     count = count + failed;
            // }
            if (added && !isNaN(added) && added >= 0) {
                count = count + added;
            }
            if (updated && !isNaN(updated) && updated >= 0) {
                count = count + updated;
            }

        } catch (e) {
            console.log(e);
            return 0;
        }
        return count;

    }

    return (
        <>
            <Grid item md={12}>
                <TableContainer>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Label</TableCell>
                                <TableCell align="right">Description</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell component="th" scope="row">
                                    <strong>Job Name:</strong>
                                </TableCell>
                                <TableCell align="right">{job.title}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">
                                    <strong>Start Date/Time:</strong>
                                </TableCell>
                                <TableCell align="right">
                                    {job.create_date
                                        ? moment(job.create_date).format(
                                            globalDateEntity.dateTimeFormat,
                                        )
                                        : null}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">
                                    <strong>End Date/Time:</strong>
                                </TableCell>
                                <TableCell align="right">
                                    {job.modify_date
                                        ? moment(job.modify_date).format(
                                            globalDateEntity.dateTimeFormat,
                                        )
                                        : null}
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell component="th" scope="row">
                                    <strong>Import File # of Records:</strong>
                                </TableCell>
                                <TableCell align="right">
                                    {job.report.total
                                        ? job.report.total
                                        : 0}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">
                                    <strong>Records Added:</strong>
                                </TableCell>
                                <TableCell align="right">
                                    {job.report.added
                                        ? job.report.added
                                        : 0}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">
                                    <strong>Records Updated:</strong>
                                </TableCell>
                                <TableCell align="right">
                                    {job.report.updated
                                        ? job.report.updated
                                        : 'N/A'}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">
                                    <strong>Records Skipped:</strong>
                                </TableCell>
                                <TableCell align="right">
                                    {getTotalSkippedRecords(job.report)}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row">
                                    <strong>Records Processed:</strong>
                                </TableCell>
                                <TableCell align="right">
                                    {getTotalProcessedRecords(job.report)}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </>
    )
}

export default ProcedureCodeImports;